<template>
  <div class="zhuanti">
    <div class="topname">
      <img :src="tipsimg5" alt="">
    </div>
    <div class="content">
      <div class="left_box">
        <p><span class="quanguo">全国</span><span class="maps">地图</span></p>
        <div class="contnetmsg">
          <div class="left_box_nav">
            <span :class="currentIndex==0?'active':'noactive'" @click="changeNav('0',0)">全部</span>
            <span :class="currentIndex==1?'active':'noactive'" @click="changeNav('dongbei',1)">东北</span>
            <span :class="currentIndex==2?'active':'noactive'" @click="changeNav('huadong',2)">华东</span>
            <span :class="currentIndex==3?'active':'noactive'" @click="changeNav('huabei',3)">华北</span>
            <span :class="currentIndex==4?'active':'noactive'" @click="changeNav('huazhong',4)">华中</span>
            <span :class="currentIndex==5?'active':'noactive'" @click="changeNav('huanan',5)">华南</span>
            <span :class="currentIndex==6?'active':'noactive'" @click="changeNav('xinan',6)">西南</span>
            <span :class="currentIndex==7?'active':'noactive'" @click="changeNav('xibei',7)">西北</span>
            <span :class="currentIndex==8?'active':'noactive'" @click="changeNav('gangaotai',8)">港澳台</span>
            <span :class="currentIndex==9?'active':'noactive'" @click="changeNav('haiwai',9)">海外</span>
          </div>
          <ul class="left_box_citylist">
            <li v-for="(item,index) in currentData" :key="index">
              <span @click="godel(item.url)">{{ item.name }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="right_box">
        <div class="topnames">
          推荐专题
        </div>
        <div class="box">
          <div v-for="item in hotdata" :key="item.SPECIAL_ID" class="imgbox" @click="goDetial(item.SPECIAL_ID)">
            <div class="shadow" />
            <img :src="item.SPECIAL_COVER" alt="">
            <p class="specialname">
              {{ item.SPECIAL_NAME }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['hotdata'],
  data() {
    return {
      allcity: [],
      currentData: [],
      currentIndex: 0,
      cityData: [
        { 'huabei': [
          { name: '北京', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade759f10000b' },
          { name: '天津', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade7999ae000c' },
          { name: '河北', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade7ae20c000d' },
          { name: '山西', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade7b1f83000e' },
          { name: '内蒙古', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade7b69ea000f' }
        ] },
        { 'dongbei': [
          { name: '辽宁', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade8284a3001e' },
          { name: '吉林', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade823a9a001d' },
          { name: '黑龙江', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade81efb6001c' }
        ] },
        { 'huadong': [
          { name: '上海', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade8011bf0017' },
          { name: '江苏', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade7f66d90015' },
          { name: '浙江', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade804ff10018' },
          { name: '安徽', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade7fabd10016' },
          { name: '福建', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade80d156001a' },
          { name: '江西', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade8090d20019' },
          { name: '山东', url: 'specialTopicDetail?contentId=4028805c6abe9ec7016abf61f5430004' }
        ] },
        { 'huazhong': [
          { name: '河南', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade7c1be40010' },
          { name: '湖北', url: 'specialTopicDetail?contentId=4028805c6abe9ec7016abeb3c9080000' },
          { name: '湖南', url: 'specialTopicDetail?contentId=4028805c6abe9ec7016abf60d0a90002' }
        ] },
        { 'huanan': [
          { name: '广东', url: 'specialTopicDetail?contentId=4028805c6abe9ec7016abf617d060003' },
          { name: '广西', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade7cd1d60011' },
          { name: '海南', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade7d310d0012' }
        ] },
        { 'xinan': [
          { name: '重庆', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade8676190028' },
          { name: '四川', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade84ae880024' },
          { name: '贵州', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade84fc2b0025' },
          { name: '云南', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade8546920026' },
          { name: '西藏', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade85aa2e0027' }
        ] },
        { 'xibei': [
          { name: '陕西', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade832b44001f' },
          { name: '甘肃', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade8371450020' },
          { name: '青海', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade8400560022' },
          { name: '宁夏', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade83b63e0021' },
          { name: '新疆', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade845b190023' }
        ] },
        { 'gangaotai': [
          { name: '香港', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade7df6af0013' },
          { name: '澳门', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade7e56340014' },
          { name: '台湾', url: 'specialTopicDetail?contentId=4028805c6ade6956016ade811228001b' }
        ] },
        { 'haiwai': [
          { name: '海外', url: 'specialTopicDetail?contentId=4028805c6ade879c016ade89562f0000' }
        ] }
      ],
      tipsimg5: require('@/static/gedi_peng.png')
    }
  },
  mounted() {
    var arr = []
    this.allcity = arr.concat(this.cityData[0]['huabei'], this.cityData[1]['dongbei'], this.cityData[2]['huadong'], this.cityData[3]['huazhong'], this.cityData[4]['huanan'], this.cityData[5]['xinan'], this.cityData[6][ 'xibei'], this.cityData[7][ 'gangaotai'], this.cityData[8][ 'haiwai'])
    this.currentData = this.allcity
  },
  methods: {
    changeNav(str, index) {
      this.currentIndex = index
      if (str !== '0') {
        for (var i = 0; i < this.cityData.length; i++) {
          if (this.cityData[i][str]) {
            this.currentData = this.cityData[i][str]
          }
        }
      } else {
        this.currentData = this.allcity
      }
    },
    godel(url) {
      window.open(url, '_blank')
    },
    goDetial: function(id) {
      // this.$router.push({ path: '/specialTopicDetail', query: { 'contentId': id }})
      const { href } = this.$router.resolve({
        path: '/specialTopicDetail',
        name: 'std',
        query: {
          contentId: id
        }
      })
      window.open(href)
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .zhuanti{
        margin-top: 20px;
        overflow: hidden;
        background-color: #323232;
        .topname{
            height: 70px;
            line-height: 70px;
            text-align: center;
            background-color: #282828;
            img{
                width: 272px;
                height: 29px;
                margin-top: 20px;
            }
        }
        .content{
            height: 478px;
            background-color: #323232;
            .left_box{
                width: 600px;
                overflow: hidden;
                display: inline-block;
                p{
                    margin-left: 25px;
                    margin-top: 30px;
                    margin-bottom: 25px;
                    .quanguo{
                        color: #c3a14f;
                        font-size: 14px;
                    }
                    .maps{
                        color: #ffffff;
                        font-size: 14px;
                        margin-left: 22px;
                    }
                }
                .contnetmsg{
                    display: inline-block;
                    width: 100%;
                    overflow: hidden;
                    .left_box_nav{
                        width: 50px;
                        overflow: hidden;
                        margin-left: 25px;
                        display: inline-block;
                        vertical-align: top;
                        span{
                            display: inline-block;
                            width: 48px;
                            height: 28px;
                            border: 1px solid #7e6b5a;
                            color: #ffffff;
                            text-align: center;
                            line-height: 30px;
                            margin-bottom: 9px;
                            font-size: 15px;
                            cursor: pointer;
                        }
                        .active{
                            background-color: #7e6b5a;
                        }
                    }
                    .left_box_citylist{
                        width: 500px;
                        overflow: hidden;
                        display: inline-block;
                        li{
                          width: 100px;
                          text-align: center;
                          height:30px;
                          margin-bottom: 15px;
                          line-height: 30px;
                          display: inline-block;
                          span{
                            color: #ebebeb;
                            cursor: pointer;
                            &:hover{
                              color: #ed4040;
                            }
                          }
                        }
                      }
                }
            }
            .right_box{
                width: 600px;
                overflow: hidden;
                display: inline-block;
                vertical-align: top;
                .topnames{
                    height: 35px;
                    line-height: 35px;
                    color: #c3a14f;
                    margin-top: 20px;
                    font-size: 16px;
                }
                .box{
                    width: 580px;
                    overflow: hidden;
                    display: inline-block;
                    .imgbox{
                        width: 280px;
                        height: 120px;
                        display: inline-block;
                        margin-right: 10px;
                        position: relative;
                        cursor: pointer;
                        font-size: 0;
                        vertical-align: top;
                        margin-top: 30px;
                        img{
                            width: 280px;
                            height: 120px;
                        }
                        .shadow{
                            width: 280px;
                            height: 120px;
                            position: absolute;
                            background-color:rgba(0,0,0,.3);
                            z-index: 2;
                            transition: 0.3s;
                            &:hover{
                                background-color:rgba(0,0,0,.0);
                            }
                        }
                        .specialname{
                            position: absolute;
                            top: 48px;
                            font-size: 18px;
                            color: #ffffff;
                            width: 100%;
                            text-align: center;
                            font-weight: 500;
                            overflow: hidden;
                            z-index: 3;
                        }
                    }
                }
            }
        }
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .zhuanti{
      .content {
        height: auto;
        .left_box{
          width: 100%;
          padding-top: 20px;
          .contnetmsg{
            .left_box_citylist{
              width: 100%;
              li{
                width: 24.5%;
              }
            }
            .left_box_nav{
              display: none;
            }
          }
          p{
            display: none;
          }
        }
        .right_box {
          width: 100%;
          .box{
            width: 100%;
            .imgbox {
              margin: 10px 3%;
              width: 94%;
              overflow: hidden;
              .shadow,p{
                width: 100%;
              }
              img{
                width: auto;
              }
            }
          }
          .topnames{
            text-align: center;
          }
        }
      }
    }
  }
</style>
